import React, {useEffect, useState} from 'react'
import {Button, Form, Modal, InputNumber, AutoComplete} from "antd";
import {createProductionProcess} from "../../services/serviceProductionProcess";
import {getAllWarehouse} from "../../services/serviceWarehouse";
import {getAllProduction} from "../../services/serviceProduction";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const statuses = [
    {
        value: "FAULT",
        text: "HATALI"
    },
    {
        value: "SUCCESS",
        text: "BAŞARILI"
    },
]
const { Option } = AutoComplete

const ProductionProcessCreate = ({show, modalCloser, updater}) => {

    const [form]= Form.useForm()
    const [selectedStatus, setSelectedStatus] = useState(null)
    const [selectedProduction, setSelectedProduction] = useState()
    const [productions, setProductions] = useState([])
    const [warehouseData, setWarehouseData] = useState([])
    const [selectedWarehouse, setSelectedWarehouse] = useState()
    const [loadings, setLoadings] = useState([])

    useEffect(() => {
        getAllProduction()
            .then(({data}) => {
                let prodData = []
                data.forEach(item => {
                    let prodItem = {
                        quantity: item.quantity,
                        text: item.productionNumber,
                        value: item.id
                    }
                    prodData.push(prodItem)
                })
                setProductions(prodData)
            })
    }, [])

    useEffect(() => {
        getAllWarehouse()
            .then(({data}) => {
                const warehouses = data.map(item => {
                    return {
                        text: item.name,
                        value: item.id
                    }
                })
                setWarehouseData(warehouses)
            })
    }, [])

    const handleWarehouseChange = (v, {key}) => key ? setSelectedWarehouse(key) : null
    const statusChanged = (v, o) => setSelectedStatus(o.key)
    const productionSelected = (v, o) => {
        if (o.key) {
            setSelectedProduction(o.key)
            const matchedItem = productions.find(production => production.value === Number(o.key))
            if (matchedItem) form.setFieldsValue({productionQuantity: matchedItem.quantity})
        } else {
            form.setFieldsValue({productionQuantity: ''})
        }
    }
    const handleSubmit = () => {
        enterLoadingState(setLoadings)
        const {
            productionQuantity
        } = form.getFieldsValue()

        let requestObj = {
            quantity: productionQuantity,
            production: {
                id: selectedProduction
            },
            productionStatus: selectedStatus,
            warehouse: {
                id: selectedWarehouse
            }
        }

        createProductionProcess(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                modalCloser()
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }


    return (
        <React.Fragment>
            <Modal
                open={show}
                closable={false}
                title={'Üretim Giriş Ekle'}
                footer={[
                    <Button
                        key={'SubmitButton'}
                        type={'primary'}
                        loading={loadings[0]}
                        onClick={form.submit}
                    >
                        Kaydet
                    </Button>,
                    <Button
                        key={'CancelButton'}
                        onClick={modalCloser}
                    >
                        Kapat
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    labelAlign={'left'}
                    labelCol={{span: 8}}
                    wrapperCol={{span: 14}}
                    onFinish={handleSubmit}
                >
                    <Form.Item label={'Üretim No'} name={'productionNo'} rules={[{required: true, message: 'Bu Alan zorunludur'}]}>
                        <AutoComplete onChange={productionSelected}>
                            {
                                productions.map(({value, text}) => {
                                    return <Option key={value} value={text}>{text}</Option>
                                })
                            }
                        </AutoComplete>
                    </Form.Item >
                    <Form.Item name={'productionQuantity'} label={'Üretim Miktarı'}>
                        <InputNumber disabled={true} min={0}/>
                    </Form.Item>
                    <Form.Item name={'warehouse'} label={'Depo'} rules={[{required: true, message: 'Bu Alan zorunludur'}]}>
                        <AutoComplete onChange={handleWarehouseChange}>
                            {
                                warehouseData.map(item => <Option key={item.value} value={item.text}>{item.text}</Option>)
                            }
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item name={'productionStatus'} label={'Üretim Durumu'} rules={[{required: true, message: 'Bu Alan zorunludur'}]}>
                        <AutoComplete
                            onChange={statusChanged}
                        >
                            {statuses.map(({value,text}) => {
                                return <Option key={value} value={text}>{text}</Option>
                            })}

                        </AutoComplete>
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default ProductionProcessCreate